<template lang="pug">
span
  div(v-if="item > 0")
    span.link-like(@click="openActiveContactsList") {{ item }}
</template>

<script>
import GetItem from '@/Core/mixins/getItem';

export default {
  name: 'active-contacts-modal',
  mixins: [GetItem],
  methods: {
    openActiveContactsList() {
      this.$emit('openActiveContactsList', this.data);
    },
  },
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.link-like {
  color: var(--v-primary-base);
  cursor: pointer;
}
</style>
